import { z } from 'zod';
import { normalizedBirthDataSchema } from '../onboarding';
import { birthDateSchema, birthTimeSchema, birthPlaceSchema, birthTimezoneSchema } from '../birth-data';
import { zodiacSignEnum } from '../../zodiac';

export const guestDataSchema = z.object({
  name: z.string().trim().min(1).max(128).optional(),
  dob: birthDateSchema.optional().nullable(),
  birthTime: birthTimeSchema.optional().nullable(),
  birthPlace: birthPlaceSchema.optional().nullable(),
  zodiacSign: zodiacSignEnum.optional(),
  normalizedBirthData: normalizedBirthDataSchema,
  birthPlaceTimezone: birthTimezoneSchema.optional().nullable(),
});

export type GuestDataInput = z.infer<typeof guestDataSchema>;
